var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.159,
    height: 14.246,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 734",
    fill: "#5300f2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 349",
    d: "M15.748 3.355L8.36.06a.688.688 0 00-.56 0L.41 3.355A.692.692 0 00.366 4.6l7.387 3.94a.693.693 0 00.652 0l7.388-3.94a.691.691 0 00-.045-1.242z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M15.142 6.302l-7.063 3.767-7.061-3.767A.692.692 0 00.367 7.52l7.387 3.943a.693.693 0 00.652 0l7.387-3.943a.692.692 0 00-.651-1.218z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 351",
    d: "M15.142 9.005l-7.063 3.766-7.061-3.766a.692.692 0 10-.651 1.218l7.387 3.94a.691.691 0 00.652 0l7.387-3.94a.692.692 0 10-.652-1.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.192766b7dd7ed6920c231bb24892f034.svg";
export { ForwardRef as ReactComponent };